export const district_data_touristic_religious = {
  "type": "FeatureCollection",
  "generator": "overpass-ide",
  "copyright": "The data included in this document is from www.openstreetmap.org. The data is made available under ODbL.",
  "timestamp": "2021-01-11T03:25:02Z",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990801562",
        "amenity": "place_of_worship",
        "name": "Ganesh Shrine",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278033,
          27.6701015
        ]
      },
      "id": "node/990801562"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990902873",
        "name": "Brass and Bronze Museum",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4355371,
          27.6736291
        ]
      },
      "id": "node/990902873"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990902874",
        "name": "Woodcarving Museum",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4355279,
          27.6733873
        ]
      },
      "id": "node/990902874"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990902931",
        "name": "National Art Gallery",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4284483,
          27.6722798
        ]
      },
      "id": "node/990902931"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990950522",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4467281,
          27.6473432
        ]
      },
      "id": "node/990950522"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1894365457",
        "amenity": "place_of_worship",
        "name": "Indrayani",
        "religion": "hindu",
        "wheelchair": "limited"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4268439,
          27.6731574
        ]
      },
      "id": "node/1894365457"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1945526719",
        "addr:city": "Thimi",
        "addr:housenumber": "14",
        "addr:street": "Balkumari",
        "amenity": "place_of_worship",
        "name": "Balkumari Temple;भैरब मन्दिर",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.38537,
          27.6759307
        ]
      },
      "id": "node/1945526719"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1945526732",
        "addr:city": "Madhyapur Thimi",
        "addr:place": "Siddhikali mandir parisad",
        "addr:street": "Siddhikali mandir marga",
        "amenity": "place_of_worship",
        "name": "Siddhikali Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3830995,
          27.680756
        ]
      },
      "id": "node/1945526732"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1945526769",
        "amenity": "place_of_worship",
        "name": "Chonga Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4110065,
          27.674308
        ]
      },
      "id": "node/1945526769"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1964172915",
        "amenity": "place_of_worship",
        "name": "Dahi Binayak",
        "religion": "hindu",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4305049,
          27.6720589
        ]
      },
      "id": "node/1964172915"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1964172925",
        "amenity": "place_of_worship",
        "name": "Tripursundari Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4304269,
          27.6727276
        ]
      },
      "id": "node/1964172925"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969476986",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4298676,
          27.6818997
        ]
      },
      "id": "node/1969476986"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969477067",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4300727,
          27.6891765
        ]
      },
      "id": "node/1969477067"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969477070",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301685,
          27.6896236
        ]
      },
      "id": "node/1969477070"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969477094",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4298604,
          27.690739
        ]
      },
      "id": "node/1969477094"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1990747005",
        "addr:city": "chochhen",
        "addr:tole": "chochhen",
        "amenity": "place_of_worship",
        "facility": "temple",
        "name": "Chhuma Ganesh Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4305836,
          27.6745426
        ]
      },
      "id": "node/1990747005"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2012066696",
        "amenity": "place_of_worship",
        "religion": "muslim"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4334196,
          27.6698129
        ]
      },
      "id": "node/2012066696"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2060240290",
        "amenity": "place_of_worship",
        "historic": "monument",
        "name": "Statue of Sleeping Narayan",
        "religion": "hindu",
        "tourism": "attraction"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4312982,
          27.6765998
        ]
      },
      "id": "node/2060240290"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2076576713",
        "amenity": "place_of_worship",
        "name": "Yatu Mahadev Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4484526,
          27.682419
        ]
      },
      "id": "node/2076576713"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2152942986",
        "amenity": "place_of_worship",
        "name": "Saraswati temple",
        "opening_hours": "06:00-00:00",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4160466,
          27.7095167
        ]
      },
      "id": "node/2152942986"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2183358246",
        "amenity": "place_of_worship",
        "designation": "Bapa Hiti",
        "name": "Bishweshwar बिश्वेस्वोर महादेव",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3876573,
          27.6747729
        ]
      },
      "id": "node/2183358246"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2200289761",
        "amenity": "place_of_worship",
        "name": "Temple of Bhairav",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4282429,
          27.6708065
        ]
      },
      "id": "node/2200289761"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2203472846",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4290432,
          27.670558
        ]
      },
      "id": "node/2203472846"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2245137965",
        "addr:city": "Madyapur Thimi 3",
        "addr:street": "Kausaltar",
        "amenity": "place_of_worship",
        "name": "Bhairab than",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3661352,
          27.6748488
        ]
      },
      "id": "node/2245137965"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2249176240",
        "amenity": "place_of_worship",
        "name": "Nilbarahi Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3963984,
          27.6954342
        ]
      },
      "id": "node/2249176240"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2249178847",
        "addr:housename": "Dadhikot",
        "amenity": "place_of_worship",
        "name": "Dakshin Barahi Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3859703,
          27.6681336
        ]
      },
      "id": "node/2249178847"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2272327532",
        "amenity": "place_of_worship",
        "name": "yapi bhairab",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4205463,
          27.6988529
        ]
      },
      "id": "node/2272327532"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2272638927",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4331767,
          27.6749065
        ]
      },
      "id": "node/2272638927"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2279168972",
        "amenity": "place_of_worship",
        "name": "kotdevi",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4323012,
          27.6960101
        ]
      },
      "id": "node/2279168972"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2291356298",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4262151,
          27.6707195
        ]
      },
      "id": "node/2291356298"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2291360341",
        "amenity": "place_of_worship",
        "name": "Mulakhu Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4268002,
          27.6704947
        ]
      },
      "id": "node/2291360341"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2299787966",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4612551,
          27.7036906
        ]
      },
      "id": "node/2299787966"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2302656481",
        "amenity": "place_of_worship",
        "name": "Chaturbahu Narayan",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4156739,
          27.701117
        ]
      },
      "id": "node/2302656481"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2318106936",
        "amenity": "place_of_worship",
        "name": "Devishowari Tempel",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3597878,
          27.6743831
        ]
      },
      "id": "node/2318106936"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2337286049",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4291961,
          27.6707605
        ]
      },
      "id": "node/2337286049"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2406617432",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4299323,
          27.6736263
        ]
      },
      "id": "node/2406617432"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2444734531",
        "amenity": "place_of_worship",
        "name": "Vatsala"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4288306,
          27.6723189
        ]
      },
      "id": "node/2444734531"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2449083911",
        "amenity": "place_of_worship",
        "name": "Dhumawati",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4303899,
          27.6718964
        ]
      },
      "id": "node/2449083911"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477469722",
        "addr:housename": "Near Chuping Ghat",
        "amenity": "place_of_worship",
        "denomination": "hindu",
        "name": "Narayan Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4299825,
          27.6683668
        ]
      },
      "id": "node/2477469722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477469723",
        "addr:housename": "side of chuping ghat",
        "amenity": "place_of_worship",
        "name": "Shiva Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301073,
          27.6682836
        ]
      },
      "id": "node/2477469723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477513503",
        "amenity": "place_of_worship",
        "name": "Shiva Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4297117,
          27.6661251
        ]
      },
      "id": "node/2477513503"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477516924",
        "amenity": "place_of_worship",
        "fixme": "What means number of blocks = 3?",
        "name": "Nasdyo",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301422,
          27.6692438
        ]
      },
      "id": "node/2477516924"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477565495",
        "addr:housename": "Bhaktapur-12",
        "amenity": "place_of_worship",
        "name": "Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4349769,
          27.6683445
        ]
      },
      "id": "node/2477565495"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477566459",
        "addr:housename": "Bhaktapur-12",
        "amenity": "place_of_worship",
        "name": "Saraswati Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4312207,
          27.6685214
        ]
      },
      "id": "node/2477566459"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477572130",
        "addr:housename": "Bhuichalo (earthquake) temple",
        "amenity": "place_of_worship",
        "name": "Bhuichalo (earthquake) temple",
        "name:en": "भिसिं द्यः",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4313179,
          27.668506
        ]
      },
      "id": "node/2477572130"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477603263",
        "amenity": "place_of_worship",
        "name": "Temple",
        "name:fr": "Temple de Jeth Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4277593,
          27.6698375
        ]
      },
      "id": "node/2477603263"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477913780",
        "amenity": "place_of_worship",
        "name": "Shrine to Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.425559,
          27.6664661
        ]
      },
      "id": "node/2477913780"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478690286",
        "Type": "Covered by iron gatte and temple between water pond",
        "amenity": "place_of_worship",
        "name": "Shree sheshnarayan temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4309071,
          27.6933565
        ]
      },
      "id": "node/2478690286"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478693248",
        "amenity": "place_of_worship",
        "name": "Ram Janaki temple",
        "religion": "hindu",
        "type": "3 blocks"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4310224,
          27.6933256
        ]
      },
      "id": "node/2478693248"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478760289",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301852,
          27.6896695
        ]
      },
      "id": "node/2478760289"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478779117",
        "amenity": "place_of_worship",
        "name": "Ganesh Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4223897,
          27.6851278
        ]
      },
      "id": "node/2478779117"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478783702",
        "amenity": "place_of_worship",
        "denomination": "Nepalies",
        "name": "Ganesh Mandhir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4286595,
          27.6698202
        ]
      },
      "id": "node/2478783702"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478794557",
        "amenity": "place_of_worship",
        "name": "ganesh mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4303062,
          27.6862256
        ]
      },
      "id": "node/2478794557"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478804460",
        "amenity": "place_of_worship",
        "name": "Chhinamasta Durga Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4216472,
          27.6884893
        ]
      },
      "id": "node/2478804460"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2609003247",
        "amenity": "place_of_worship",
        "name": "Balakhu ganesh temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4293774,
          27.6726473
        ]
      },
      "id": "node/2609003247"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2824165215",
        "addr:city": "Thimi",
        "addr:street": "Ajima Nani",
        "amenity": "place_of_worship",
        "name": "अजिमा मन्दिर",
        "note": "Anapurna Ajima Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3832455,
          27.6764898
        ]
      },
      "id": "node/2824165215"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2824216265",
        "addr:city": "Thimi",
        "amenity": "place_of_worship",
        "name": "Bishnu Bir Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3839927,
          27.6762287
        ]
      },
      "id": "node/2824216265"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2824301701",
        "amenity": "place_of_worship",
        "name": "लोकेश्वोर मन्दिर",
        "religion": "buddhist;hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3856568,
          27.6763795
        ]
      },
      "id": "node/2824301701"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3039065476",
        "amenity": "place_of_worship",
        "denomination": "Ganesh",
        "name": "Suryabinayak Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4234873,
          27.6563094
        ]
      },
      "id": "node/3039065476"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3072782147",
        "amenity": "place_of_worship",
        "name": "Neel-Barahi Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3889836,
          27.6918577
        ]
      },
      "id": "node/3072782147"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3072784499",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3883383,
          27.6902908
        ]
      },
      "id": "node/3072784499"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3072784500",
        "amenity": "place_of_worship",
        "name": "Pacho Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3868534,
          27.6917808
        ]
      },
      "id": "node/3072784500"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212840",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3887193,
          27.6909653
        ]
      },
      "id": "node/3081212840"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212841",
        "amenity": "place_of_worship",
        "name": "Mahadev Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3887294,
          27.6909601
        ]
      },
      "id": "node/3081212841"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212842",
        "amenity": "place_of_worship",
        "name": "Narayan Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3888303,
          27.6908827
        ]
      },
      "id": "node/3081212842"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212875",
        "amenity": "place_of_worship",
        "name": "peepal bot",
        "natural": "tree",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3886174,
          27.6902783
        ]
      },
      "id": "node/3081212875"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212876",
        "amenity": "place_of_worship",
        "name": "pipal bot",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3898665,
          27.6905689
        ]
      },
      "id": "node/3081212876"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081213061",
        "amenity": "place_of_worship",
        "building": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3917126,
          27.6915993
        ]
      },
      "id": "node/3081213061"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3132479368",
        "amenity": "place_of_worship",
        "name": "mahalaxmi mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3881367,
          27.6921884
        ]
      },
      "id": "node/3132479368"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3143339051",
        "amenity": "place_of_worship",
        "name": "Narayan Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3895768,
          27.6918788
        ]
      },
      "id": "node/3143339051"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151907534",
        "amenity": "place_of_worship",
        "name": "Gorakhnath Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3857143,
          27.6916727
        ]
      },
      "id": "node/3151907534"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151907535",
        "amenity": "place_of_worship",
        "name": "Kumari Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3858556,
          27.6919577
        ]
      },
      "id": "node/3151907535"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151911661",
        "amenity": "place_of_worship",
        "name": "Narayan Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3881342,
          27.6913667
        ]
      },
      "id": "node/3151911661"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151911662",
        "amenity": "place_of_worship",
        "name": "Peepal bot",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.388481,
          27.6923842
        ]
      },
      "id": "node/3151911662"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3157663313",
        "amenity": "place_of_worship",
        "name": "krishna mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4012316,
          27.6630837
        ]
      },
      "id": "node/3157663313"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3157670629",
        "amenity": "place_of_worship",
        "name": "Subarneshwor Mahadev",
        "name:ne": "सुबर्णेश्वोर महादेव",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4088008,
          27.6593164
        ]
      },
      "id": "node/3157670629"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3493526205",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4359238,
          27.6748679
        ]
      },
      "id": "node/3493526205"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3493526835",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4363324,
          27.6747042
        ]
      },
      "id": "node/3493526835"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3493526953",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4366943,
          27.6745212
        ]
      },
      "id": "node/3493526953"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3678942236",
        "addr:street": "itachhen",
        "amenity": "place_of_worship",
        "name": "Lokeswor",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4255992,
          27.672121
        ]
      },
      "id": "node/3678942236"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4133403025",
        "addr:city": "Madhyapur Thimi",
        "addr:street": "Digu Tole",
        "amenity": "place_of_worship",
        "name": "प्रचन्द भैरब मन्दिर",
        "name:en": "Prachanda Bhairav Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3856831,
          27.6791536
        ]
      },
      "id": "node/4133403025"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4133403026",
        "addr:city": "Madhyapur Thimi",
        "addr:street": "Digu Tol",
        "amenity": "place_of_worship",
        "name": "दिगु बाहा",
        "name:en": "Guna Kirti Mahabihar",
        "name:ne": "गुन किर्ति माहाबिर",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3860602,
          27.6795595
        ]
      },
      "id": "node/4133403026"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4133418725",
        "addr:city": "Madhyapur Thimi",
        "addr:street": "Dev Tol",
        "amenity": "place_of_worship",
        "name": "Bandevi Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3859859,
          27.6741947
        ]
      },
      "id": "node/4133418725"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4235575290",
        "addr:street": "Wamune",
        "amenity": "place_of_worship",
        "name": "Wamune Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3866944,
          27.6757803
        ]
      },
      "id": "node/4235575290"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4235620292",
        "amenity": "place_of_worship",
        "name": "Bisheswor Mahadev",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3874632,
          27.6747647
        ]
      },
      "id": "node/4235620292"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4243030034",
        "amenity": "place_of_worship",
        "name:en": "Sankhadhar sakhwa"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3853146,
          27.6736379
        ]
      },
      "id": "node/4243030034"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4243043010",
        "amenity": "place_of_worship",
        "name": "Bandevi"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3858243,
          27.6743477
        ]
      },
      "id": "node/4243043010"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4264053777",
        "amenity": "place_of_worship",
        "name": "bhairav temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3588987,
          27.6716161
        ]
      },
      "id": "node/4264053777"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4278670646",
        "addr:street": "tinachhen",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4354447,
          27.6747549
        ]
      },
      "id": "node/4278670646"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295561600",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3845059,
          27.6850169
        ]
      },
      "id": "node/4295561600"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295562614",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3843232,
          27.68523
        ]
      },
      "id": "node/4295562614"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295590488",
        "amenity": "place_of_worship",
        "name": "Nagadesh siddhi ganesh temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3843849,
          27.6842082
        ]
      },
      "id": "node/4295590488"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295592848",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3845417,
          27.6849901
        ]
      },
      "id": "node/4295592848"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4313008926",
        "addr:city": "Madhyapur Thimi Municipality",
        "addr:place": "Bahakha bazar - 6",
        "addr:street": "Madhyapur thimi marga",
        "amenity": "place_of_worship",
        "name": "bhimshen mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3873016,
          27.6831377
        ]
      },
      "id": "node/4313008926"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4313036674",
        "amenity": "place_of_worship",
        "name": "krishna temple",
        "religion": "shinto"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.381905,
          27.6894085
        ]
      },
      "id": "node/4313036674"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4314051225",
        "amenity": "place_of_worship",
        "name": "Balkumari temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4374267,
          27.6743645
        ]
      },
      "id": "node/4314051225"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4314057248",
        "amenity": "place_of_worship",
        "name": "Ganesh Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4373087,
          27.6740469
        ]
      },
      "id": "node/4314057248"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324787247",
        "amenity": "place_of_worship",
        "name": "Paanchmukhi Hanuman temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4543185,
          27.7106661
        ]
      },
      "id": "node/4324787247"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324794311",
        "amenity": "place_of_worship",
        "name": "Jalapadevi Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4777181,
          27.7102292
        ]
      },
      "id": "node/4324794311"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324799335",
        "amenity": "place_of_worship",
        "name": "Small white gomba",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4905605,
          27.7125468
        ]
      },
      "id": "node/4324799335"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324892087",
        "amenity": "place_of_worship",
        "name": "Kaali Devi Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.453662,
          27.7109207
        ]
      },
      "id": "node/4324892087"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4329256591",
        "amenity": "place_of_worship",
        "name": "Degaina Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4412005,
          27.6737189
        ]
      },
      "id": "node/4329256591"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4342388489",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.387281,
          27.6826939
        ]
      },
      "id": "node/4342388489"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4360771393",
        "amenity": "place_of_worship",
        "name": "Mahadev Sthan",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.386169,
          27.6831087
        ]
      },
      "id": "node/4360771393"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4365880992",
        "amenity": "place_of_worship",
        "name": "Sileshwor Mahadev (Bisantaki Tole) Nagadesh",
        "name:en": "Sileshwor Mahadev (Bisantaki Tole) Nagadesh",
        "name:ne": "सिलेस्वर महादेव,  बिसन्तकी टोल, नगदेश",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3814433,
          27.6874613
        ]
      },
      "id": "node/4365880992"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4375884789",
        "addr:street": "Telcot-Changu Road",
        "amenity": "place_of_worship",
        "name:en": "panchamaha Laxmi Temple",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4721753,
          27.7167306
        ]
      },
      "id": "node/4375884789"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4380964290",
        "addr:street": "Napookhu",
        "amenity": "place_of_worship",
        "name": "Thathu Bahi",
        "name:en": "Thathu Bahi",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4227956,
          27.6728095
        ]
      },
      "id": "node/4380964290"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4394565690",
        "amenity": "place_of_worship",
        "name:en": "Shree Radha Krishna Temple",
        "name:hi": "श्री राधाकृष्ण मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4654596,
          27.6968922
        ]
      },
      "id": "node/4394565690"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4395911590",
        "amenity": "place_of_worship",
        "name:en": "Muhan Ganesh Temple",
        "name:hi": "मुहान गणेश मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4827612,
          27.7047993
        ]
      },
      "id": "node/4395911590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4396988690",
        "amenity": "place_of_worship",
        "name:en": "Panchamukhi Hanuman Temple",
        "name:hi": "पँन्चमुखी हनुमान मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4534263,
          27.7107045
        ]
      },
      "id": "node/4396988690"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4396994889",
        "amenity": "place_of_worship",
        "name:en": "Bagehiti Temple",
        "name:hi": "बागेहिटी मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4840471,
          27.6995939
        ]
      },
      "id": "node/4396994889"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4413342541",
        "amenity": "place_of_worship",
        "name": "Temple",
        "name:fr": "Temple de Vishnu",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278531,
          27.6698786
        ]
      },
      "id": "node/4413342541"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4432030050",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.380926,
          27.6893476
        ]
      },
      "id": "node/4432030050"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4465721390",
        "amenity": "place_of_worship",
        "name:en": "Shyam Shyam Sadhana Sadan"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4000653,
          27.6747958
        ]
      },
      "id": "node/4465721390"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4471169590",
        "addr:street": "Purano Thimi- Naya Thimi",
        "amenity": "place_of_worship",
        "name:en": "Purbasthit Mahavihar ( Jiswanbahal )"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3865708,
          27.6816894
        ]
      },
      "id": "node/4471169590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4472634991",
        "addr:street": "bappa marg , Bishweshwor nagar",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3875529,
          27.6747591
        ]
      },
      "id": "node/4472634991"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4476159389",
        "addr:city": "Madhyapur Thimi Municipality",
        "addr:place": "Swaga Pukhu - 6",
        "addr:street": "Swanga Pukhu Marga",
        "amenity": "place_of_worship",
        "historic": "monument",
        "name": "Vidhyaganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3865107,
          27.6817928
        ]
      },
      "id": "node/4476159389"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4506496796",
        "amenity": "place_of_worship",
        "name:en": "Shree Radha Krishna Mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4702841,
          27.7024363
        ]
      },
      "id": "node/4506496796"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4506511892",
        "amenity": "place_of_worship",
        "name:en": "Bhimsenthan"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4803671,
          27.6994111
        ]
      },
      "id": "node/4506511892"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4513012589",
        "amenity": "place_of_worship",
        "name:en": "Shiv lig"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.437826,
          27.6744175
        ]
      },
      "id": "node/4513012589"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4533150690",
        "amenity": "place_of_worship",
        "name": "Somlingeshwar Mahadev",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3857214,
          27.648814
        ]
      },
      "id": "node/4533150690"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4533218789",
        "amenity": "place_of_worship",
        "name:en": "om shanti mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4751913,
          27.6863416
        ]
      },
      "id": "node/4533218789"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4560171195",
        "amenity": "place_of_worship",
        "name:en": "Shree Manakamana Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4614571,
          27.7073442
        ]
      },
      "id": "node/4560171195"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4576562692",
        "amenity": "place_of_worship",
        "name:en": "Balmikeshwor Jotirlinga"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.482354,
          27.693249
        ]
      },
      "id": "node/4576562692"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4576612890",
        "amenity": "place_of_worship",
        "name:en": "Lokeshwor Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4607798,
          27.6949635
        ]
      },
      "id": "node/4576612890"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4590558910",
        "amenity": "place_of_worship",
        "name:en": "Shree Santoshimata Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4667328,
          27.6972178
        ]
      },
      "id": "node/4590558910"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4605332689",
        "amenity": "place_of_worship",
        "name:en": "Subarneshwor"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4143071,
          27.6625698
        ]
      },
      "id": "node/4605332689"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4624545490",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3866389,
          27.6575655
        ]
      },
      "id": "node/4624545490"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4643556590",
        "addr:street": "Balkot-Biruwa Road",
        "amenity": "place_of_worship",
        "name:en": "Bindhabashini"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.394351,
          27.6381491
        ]
      },
      "id": "node/4643556590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4692191194",
        "amenity": "place_of_worship",
        "name:en": "Kingdom hall of Jehovha's Witnesses"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4117544,
          27.6703836
        ]
      },
      "id": "node/4692191194"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4693748200",
        "addr:street": "Siwa Tole",
        "amenity": "place_of_worship",
        "name:en": "Mahadev Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3864642,
          27.6775685
        ]
      },
      "id": "node/4693748200"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4693751297",
        "addr:street": "Lakayu",
        "amenity": "place_of_worship",
        "name:en": "Bhairav"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3857063,
          27.6773156
        ]
      },
      "id": "node/4693751297"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4693753093",
        "addr:street": "Siwa Tole",
        "amenity": "place_of_worship",
        "name:en": "Shiva Ganesh temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3864692,
          27.6775498
        ]
      },
      "id": "node/4693753093"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4713210889",
        "amenity": "place_of_worship",
        "name:en": "Shree Radhakrishna Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4803236,
          27.686439
        ]
      },
      "id": "node/4713210889"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4713210989",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4735823,
          27.686718
        ]
      },
      "id": "node/4713210989"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4765999654",
        "amenity": "place_of_worship",
        "name": "Shiv Ling"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4902861,
          27.6668011
        ]
      },
      "id": "node/4765999654"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4773049821",
        "addr:city": "bhaktapur municipality",
        "addr:place": "libali-8",
        "addr:street": "bagiswori school to khwopa engineering college",
        "amenity": "place_of_worship",
        "email": "you3kesh@gmail.com",
        "name:en": "गणेश मन्दिर",
        "phone": "9849127957"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4393767,
          27.6724165
        ]
      },
      "id": "node/4773049821"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4849852221",
        "amenity": "place_of_worship",
        "name:en": "Jageshwor Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4737932,
          27.7009358
        ]
      },
      "id": "node/4849852221"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4940187723",
        "amenity": "place_of_worship",
        "name:en": "Ganesh Temple",
        "name:hi": "Ganesh Than"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3649208,
          27.669708
        ]
      },
      "id": "node/4940187723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4945182722",
        "amenity": "place_of_worship",
        "name:en": "Harihardham Balkot"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.375991,
          27.6604541
        ]
      },
      "id": "node/4945182722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002664276",
        "addr:city": "bhaktapur municipality",
        "addr:place": "wachu tole",
        "amenity": "place_of_worship",
        "name": "Narayan temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4348949,
          27.6721381
        ]
      },
      "id": "node/5002664276"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002675944",
        "addr:city": "bhaktapur municipality",
        "addr:place": "jela-8",
        "amenity": "place_of_worship",
        "name": "Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4357171,
          27.6725899
        ]
      },
      "id": "node/5002675944"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002682724",
        "addr:city": "bhaktapur municipality",
        "addr:place": "jela-8",
        "amenity": "place_of_worship",
        "name": "Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4357076,
          27.6726992
        ]
      },
      "id": "node/5002682724"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002685857",
        "addr:city": "bhaktapur municipality",
        "addr:place": "jela-8",
        "amenity": "place_of_worship",
        "name": "Macho Bhairab"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4358727,
          27.6719461
        ]
      },
      "id": "node/5002685857"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5032163221",
        "addr:street": "Arniko Raj Marga",
        "amenity": "place_of_worship",
        "name:en": "Latarambeshwor"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4838529,
          27.6469049
        ]
      },
      "id": "node/5032163221"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275131021",
        "amenity": "place_of_worship",
        "name:en": "Bhuichampa Devi Temple Gankhu",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3982407,
          27.6849708
        ]
      },
      "id": "node/5275131021"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275144823",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3947228,
          27.6830894
        ]
      },
      "id": "node/5275144823"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275169921",
        "amenity": "place_of_worship",
        "name:en": "Akash Devi Temple Gankhu Dharmapur",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3970241,
          27.6849326
        ]
      },
      "id": "node/5275169921"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275243025",
        "addr:postcode": "+9771",
        "addr:street": "gankhu",
        "amenity": "place_of_worship",
        "name:en": "Bhuichapa Devi Temple Gankhu Dharmapur",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3982584,
          27.6847661
        ]
      },
      "id": "node/5275243025"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5276269721",
        "amenity": "place_of_worship",
        "name:en": "Ganesh temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.396652,
          27.6853474
        ]
      },
      "id": "node/5276269721"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5285663722",
        "amenity": "place_of_worship",
        "name:en": "God Shiva Temple Dharmapur",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3989033,
          27.6881181
        ]
      },
      "id": "node/5285663722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5285665922",
        "amenity": "place_of_worship",
        "name:en": "Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3985877,
          27.6869437
        ]
      },
      "id": "node/5285665922"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5287388021",
        "amenity": "place_of_worship",
        "name:en": "Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4005983,
          27.6894224
        ]
      },
      "id": "node/5287388021"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5325557268",
        "amenity": "place_of_worship",
        "name:en": "Ni Bahal"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.425444,
          27.6711925
        ]
      },
      "id": "node/5325557268"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5325557357",
        "amenity": "place_of_worship",
        "name:en": "Sri Indravarta Mahavihar"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4342149,
          27.6720953
        ]
      },
      "id": "node/5325557357"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5360373222",
        "addr:postcode": "977",
        "addr:street": "Byasi",
        "amenity": "place_of_worship",
        "name:en": "Krishp Dai Basne Ghar",
        "phone": "9843041030"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4287651,
          27.6751057
        ]
      },
      "id": "node/5360373222"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5362350119",
        "addr:place": "Madyapur Thimi 9",
        "addr:street": "Nilbarahi Road",
        "amenity": "place_of_worship",
        "name": "Nilkanthesor Mahadev",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3935179,
          27.6920142
        ]
      },
      "id": "node/5362350119"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5388482124",
        "addr:postcode": "977",
        "addr:street": "road",
        "amenity": "place_of_worship",
        "name:en": "Ganta Ganesh Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3847537,
          27.6752744
        ]
      },
      "id": "node/5388482124"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5498199028",
        "amenity": "place_of_worship",
        "name": "छोलेश्वर महाद्यं"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295267,
          27.6788428
        ]
      },
      "id": "node/5498199028"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5498199128",
        "amenity": "place_of_worship",
        "name:en": "ब्रम्हायणी द्याेछें"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4367249,
          27.673634
        ]
      },
      "id": "node/5498199128"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5519977554",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4754319,
          27.6435529
        ]
      },
      "id": "node/5519977554"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5532464321",
        "addr:street": "Nagadesh Marg",
        "amenity": "place_of_worship",
        "name:en": "Narayan Sthan, Nagadesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3871023,
          27.6849946
        ]
      },
      "id": "node/5532464321"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5555550776",
        "amenity": "place_of_worship",
        "name": "Mul Dipankar Bihar"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.434266,
          27.6750772
        ]
      },
      "id": "node/5555550776"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5828845485",
        "amenity": "place_of_worship",
        "name:en": "Ishaneshwor Mahadev Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.404389,
          27.6739721
        ]
      },
      "id": "node/5828845485"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5856222132",
        "amenity": "place_of_worship",
        "denomination": "hindu",
        "name": "Balkumari Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3853115,
          27.6758838
        ]
      },
      "id": "node/5856222132"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6065420348",
        "name": "National Art Museum",
        "toilets:wheelchair": "no",
        "tourism": "museum",
        "wheelchair": "limited"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4288879,
          27.6725543
        ]
      },
      "id": "node/6065420348"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6065420349",
        "amenity": "place_of_worship",
        "name": "Nyatapola temple",
        "religion": "hindu",
        "toilets:wheelchair": "no",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295166,
          27.6714788
        ]
      },
      "id": "node/6065420349"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6081068390",
        "amenity": "place_of_worship",
        "name:en": "krishna mandir kumari pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.436086,
          27.6519095
        ]
      },
      "id": "node/6081068390"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6085423487",
        "amenity": "place_of_worship",
        "name:en": "Katunje Krishna Pranami Mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4158048,
          27.6626723
        ]
      },
      "id": "node/6085423487"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6296924387",
        "amenity": "place_of_worship",
        "name:en": "Sipadol Manakamana Mai",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4360603,
          27.645889
        ]
      },
      "id": "node/6296924387"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6313577288",
        "addr:street": "Kaushaltar-Balkot",
        "amenity": "place_of_worship",
        "email": "eziolayra@gmail.com",
        "name:en": "Ganesh Than(swarswoti mandir)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3633515,
          27.67398
        ]
      },
      "id": "node/6313577288"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6323244285",
        "amenity": "place_of_worship",
        "name:en": "Shiva Mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4049238,
          27.7049345
        ]
      },
      "id": "node/6323244285"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6397585285",
        "amenity": "place_of_worship",
        "name:en": "Doleshor mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4384773,
          27.6389239
        ]
      },
      "id": "node/6397585285"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499238772",
        "amenity": "place_of_worship",
        "name": "Shree Champakpur Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4297837,
          27.7162884
        ]
      },
      "id": "node/6499238772"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499243431",
        "amenity": "place_of_worship",
        "name": "Pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4293389,
          27.7164231
        ]
      },
      "id": "node/6499243431"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499243432",
        "name": "Changu Museum",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4292412,
          27.7165172
        ]
      },
      "id": "node/6499243432"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499299166",
        "amenity": "place_of_worship",
        "name": "Paati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4283486,
          27.7164378
        ]
      },
      "id": "node/6499299166"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499299167",
        "amenity": "place_of_worship",
        "name": "Changunarayan Tol Sudhar Samiti, Balambu Paati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4285075,
          27.7164187
        ]
      },
      "id": "node/6499299167"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499299168",
        "amenity": "place_of_worship",
        "name": "Balambu Pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4285974,
          27.7164115
        ]
      },
      "id": "node/6499299168"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501663543",
        "amenity": "place_of_worship",
        "name": "Kilshwor Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278407,
          27.716319
        ]
      },
      "id": "node/6501663543"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501663544",
        "amenity": "place_of_worship",
        "name": "Shiv Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.427897,
          27.7162741
        ]
      },
      "id": "node/6501663544"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501663545",
        "amenity": "place_of_worship",
        "name": "Vishnu Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278136,
          27.716287
        ]
      },
      "id": "node/6501663545"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501755123",
        "amenity": "place_of_worship",
        "name": "Purba Bhadel Kul Devata"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4268631,
          27.7158285
        ]
      },
      "id": "node/6501755123"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6502071468",
        "amenity": "place_of_worship",
        "name": "Bhairav Pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4274492,
          27.7161861
        ]
      },
      "id": "node/6502071468"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6528690586",
        "amenity": "place_of_worship",
        "name": "Ganesthan",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3634596,
          27.673937
        ]
      },
      "id": "node/6528690586"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6547050125",
        "addr:city": "bhaktapur municipality",
        "amenity": "place_of_worship",
        "name": "Maheshori Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4358933,
          27.6706824
        ]
      },
      "id": "node/6547050125"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6694350159",
        "amenity": "place_of_worship",
        "name": "Gorakhnath Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4277972,
          27.6702168
        ]
      },
      "id": "node/6694350159"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6694544520",
        "amenity": "place_of_worship",
        "name": "Sisakoti Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3548083,
          27.6687892
        ]
      },
      "id": "node/6694544520"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6694544521",
        "amenity": "place_of_worship",
        "name": "Hanuman Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3525861,
          27.6682107
        ]
      },
      "id": "node/6694544521"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6955722189",
        "amenity": "place_of_worship",
        "name": "Chatrapal Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4233316,
          27.6972539
        ]
      },
      "id": "node/6955722189"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6955722198",
        "amenity": "place_of_worship",
        "name": "Krishna Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4203707,
          27.6982888
        ]
      },
      "id": "node/6955722198"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7175527186",
        "addr:street": "byasi",
        "amenity": "place_of_worship",
        "name:en": "Mahakali"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4311223,
          27.6759675
        ]
      },
      "id": "node/7175527186"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7176386288",
        "amenity": "place_of_worship",
        "name:en": "Laghu ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295464,
          27.6746951
        ]
      },
      "id": "node/7176386288"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7176386289",
        "amenity": "place_of_worship",
        "name:en": "Narayan dyocha"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4296085,
          27.6746474
        ]
      },
      "id": "node/7176386289"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7176398386",
        "amenity": "place_of_worship",
        "name:en": "Ram sita temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295617,
          27.6746478
        ]
      },
      "id": "node/7176398386"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7688040704",
        "amenity": "place_of_worship",
        "name": "Ganesh mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3620737,
          27.6740023
        ]
      },
      "id": "node/7688040704"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7798016813",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3669954,
          27.680606
        ]
      },
      "id": "node/7798016813"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7823639985",
        "amenity": "place_of_worship",
        "name:en": "Gankhu pipal dev",
        "name:hi": "गाँखु पिपल देब"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3984437,
          27.6800763
        ]
      },
      "id": "node/7823639985"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7823670485",
        "addr:postcode": "44811",
        "addr:street": "Gankhu marg",
        "amenity": "place_of_worship",
        "name:en": "Gankhu Mahadev mandir",
        "name:hi": "गाँखु महादेब मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3948072,
          27.6885393
        ]
      },
      "id": "node/7823670485"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8049295009",
        "amenity": "place_of_worship",
        "name": "Shiva Statue"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3660189,
          27.6731116
        ]
      },
      "id": "node/8049295009"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8080174158",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4092237,
          27.6488234
        ]
      },
      "id": "node/8080174158"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8080174159",
        "amenity": "place_of_worship",
        "name": "Radha Krishna Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4091774,
          27.6476548
        ]
      },
      "id": "node/8080174159"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8080189726",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4051003,
          27.6503187
        ]
      },
      "id": "node/8080189726"
    }
  ]
}
